/** @jsx jsx */
import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import React from 'react';

const containerStyles = css({ position: 'relative', display: 'inline-block' });
const overlayStyles = css({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: token('color.background.accent.gray.subtler'),
	pointerEvents: 'auto',
	borderRadius: token('radius.small'),
	zIndex: 100,
});

/**
 * Experimental component for wrapping UI Kit components with a skeleton overlay as a loading indicator.
 */
export const ExperimentalSkeletonOverlayWrapper = ({ children }: { children: React.ReactNode }) => (
	<div css={containerStyles}>
		<div css={overlayStyles} />
		{children}
	</div>
);
